export default __webpack_public_path__ + "static/media/collapseArrow.79b6c652.svg";